/**
 * Country flag as an IMAGE, not an emoji.
 *
 * Windows has no flag-emoji glyphs, so the regional-indicator approach renders
 * as the bare country code ("GB") on desktop. A small flag image renders the
 * same everywhere. Source: flagcdn.com (free, keyless, ISO alpha-2 codes).
 */
interface Props {
  code: string | null | undefined;
  className?: string;
}

export function FlagIcon({ code, className }: Props) {
  const cc = (code ?? '').trim().toLowerCase();
  if (cc.length !== 2 || !/^[a-z]{2}$/.test(cc)) return null;
  return (
    <img
      className={className}
      src={`https://flagcdn.com/24x18/${cc}.png`}
      srcSet={`https://flagcdn.com/48x36/${cc}.png 2x`}
      width={24}
      height={18}
      alt=""
      loading="lazy"
      style={{ display: 'inline-block', verticalAlign: '-3px', borderRadius: '2px' }}
    />
  );
}
